import React from "react";
import { formatCurrency } from '../../service/format';

export default function CardResume(props){
    var valueTotal = props?.trucks?.reduce((previous, current) => previous + current.amount, 0);
    return (
        <>
            <div className="col-12 md:col-6 grid">
                <div className="col-12 lg:col-6">
                    <div className="card mb-0">
                        <div className="flex justify-content-between mb-3">
                            <div>
                                <span className="block text-500 font-medium mb-3">Viagens Concluídas</span>
                                <div className="text-900 font-medium text-xl">{props?.data.totalTravels || 0}</div>
                            </div>
                            <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                                <i className="pi pi-map text-blue-500 text-xl"/>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="col-12 lg:col-6">
                    <div className="card mb-0">
                        <div className="flex justify-content-between mb-3">
                            <div>
                                <span className="block text-500 font-medium mb-3">Faturamento Bruto</span>
                                <div className="text-900 font-medium text-xl">{formatCurrency(props?.data?.amountTravels || 0, true)}</div>
                            </div>
                            <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                                <i className="pi pi-money-bill text-orange-500 text-xl"/>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
                <div className="col-12 lg:col-6">
                    <div className="card mb-0">
                        <div className="flex justify-content-between mb-3">
                            <div>
                                <span className="block text-500 font-medium mb-3">Despesas</span>
                                <div className="text-900 font-medium text-xl">{formatCurrency(props?.data?.amountExpenses || 0, true)}</div>
                            </div>
                            <div className="flex align-items-center justify-content-center bg-purple-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                                <i className="pi pi-wallet text-purple-500 text-xl"/>
                            </div>
                        </div>
                    </div>
                </div> 
                <div className="col-12 lg:col-6">
                    <div className="card mb-0">
                        <div className="flex justify-content-between mb-3">
                            <div>
                                <span className="block text-500 font-medium mb-3">Distância Percorrida</span>
                                <div className="text-900 font-medium text-xl">{formatCurrency(props?.data?.amountKilometers || 0)} Km</div>
                            </div>
                            <div className="flex align-items-center justify-content-center bg-purple-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                                <i className="pi pi-map-marker text-purple-500 text-xl"/>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            <div className="col-12 md:col-6 grid">
                <div className="col-12">
                    <div className="card" style={{ overflow: "auto", margin: 0, height: '100%', maxHeight: '100%' }}>
                        <div className="flex justify-content-between align-items-center mb-5">
                            <h5>Faturamento por Caminhão</h5>
                        </div>
                        <ul className="list-none p-0 m-0">
                            {props?.trucks.filter(({ amount }) => amount > 0).map(truck => {
                                const percent = (truck.amount / valueTotal * 100).toFixed(2);
                                return (
                                    <li key={truck.plate} className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-2">
                                        <div>
                                            <span className="text-900 font-medium mr-2 mb-1 md:mb-0">{truck.plate.toUpperCase()}</span>
                                        </div>
                                        <div>
                                            <div className="mt-2 md:mt-0 ml-0 md:ml-8 flex align-items-center">
                                                <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{height: '8px'}}>
                                                    <div className="bg-cyan-500 h-full" style={{width: `${percent}%`}}/>
                                                </div>
                                                <span className="text-cyan-500 ml-3 font-medium">{formatCurrency(parseFloat(percent), false, 2).toLocaleString().padStart(5, "0")}%</span>
                                            </div>
                                            <div className="mt-2" style={{ textAlign: "right" }}>{formatCurrency(truck.amount || 0, true)}</div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}